module.exports = __webpack_public_path__ + "img/social-1.9522b209.png";